import ErrorHandler from './evans/plugins/ErrorHandler'
import store from './store/index'
import {progress} from './plugins/progress'
import axios from 'axios'
import {isTauriRuntime, POS_API_ORIGIN} from './platform/tauri'
import {createTauriHttpAdapter, clearTauriSessionCookies} from './platform/tauriHttpAdapter'

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if (isTauriRuntime()) {
    axios.defaults.baseURL = POS_API_ORIGIN
    axios.defaults.adapter = createTauriHttpAdapter()
} else if (import.meta.env.PROD) {
    axios.defaults.baseURL = POS_API_ORIGIN
} else {
    // Keep development requests same-origin so every API call goes through
    // Vite's proxy, regardless of whether the browser uses localhost or
    // 127.0.0.1. A direct cross-origin base URL would reintroduce CORS.
    axios.defaults.baseURL = ''
}

if (store.getters['user/user']) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${store.getters['user/user'].token}`;
}

axios.interceptors.request.use(config => {
    progress.start()
    return config
})

axios.interceptors.response.use(
    (res) => {
        progress.finish()
        if (!res) {
            //window.vm.$message.warning( __('현재 서버 접속이 원활하지 않습니다. 새로고침 해 주세요.', 'Server is busy now. Please refresh this web page.'));

        }
        return res;
    },
    error => {
        progress.fail()
        return ErrorHandler(error)
    },
);

export default axios
export {clearTauriSessionCookies}
